import { render, staticRenderFns } from "./ItemRefList.vue?vue&type=template&id=d4b63dc8&scoped=true&"
import script from "./ItemRefList.vue?vue&type=script&lang=ts&"
export * from "./ItemRefList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemRefList.vue?vue&type=style&index=0&id=d4b63dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b63dc8",
  null
  
)

export default component.exports